import constants from "lib/constants";

const { RequestTypes } = constants;

export const isHiddenRiskSettingRequest = (item) => {
  if (!item || item.type !== RequestTypes.RISKSETTING) {
    return false;
  }

  if (item.ext?.field === "re_enable") {
    return true;
  }

  if (item.ext?.field === "auto_liquidate" && item.riskPlatform !== "DAS") {
    return true;
  }

  return false;
};

export const isVisibleRequestInOverviewTables = (item) =>
  !isHiddenRiskSettingRequest(item);
